import { requireNonNullable } from '@disy/lib/custom-error';
import { getDisyNamespace } from '@disy/lib/disy';

/**
 * @see Published The whole api is published
 * Changes here needs to be documented in web-analytics-api.adoc
 */

interface BaseWebAnalyticsEventDetail<C = string, A = string> {
  /** High level category of the event */
  category: C;
  /** Specific action or type within the category */
  action: A;
}

export type ExportActionType =
  | 'csv'
  | 'excel'
  | 'geopackage'
  | 'image'
  | 'kml'
  | 'gpx'
  | 'shapefile'
  | 'curated_report'
  | 'adhoc_report';
export type ExportEntityType = 'workbook' | 'worksheet' | 'view' | 'view_individual_values' | 'layer';

interface ExportWebAnalyticsEventDetail<
  A extends ExportActionType = Exclude<ExportActionType, 'curated_report'>,
  E extends ExportEntityType = ExportEntityType,
> extends BaseWebAnalyticsEventDetail<'export', A> {
  /** Type of entity associated with the category and action */
  entityType: E;
  /** Print name of the entity */
  entityPrintName: string;
  /** Print name of the workbook */
  workbookPrintName: string;
  /** Print name of the worksheet. Not available when entityType is 'workbook' */
  worksheetPrintName?: string;
}

interface CuratedReportExportWebAnalyticsEventDetail extends ExportWebAnalyticsEventDetail<
  'curated_report',
  'workbook'
> {
  /** Print name of the report template */
  reportTemplatePrintName: string;
}

type WebAnalyticsEventDetail = ExportWebAnalyticsEventDetail | CuratedReportExportWebAnalyticsEventDetail;

export class WebAnalyticsApi extends EventTarget {}

export function dispatchWebAnalyticsEvent(detail: WebAnalyticsEventDetail) {
  requireNonNullable(getDisyNamespace().webAnalyticsApi).dispatchEvent(new CustomEvent('action', { detail }));
}
